import React from 'react';
import { bool, node } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import classNames from 'classnames';

import { FormattedMessage, injectIntl, intlShape } from '../../../util/reactIntl';
import * as validators from '../../../util/validators';
import { Form, PrimaryButton, FieldTextInput, FieldSelect, FieldRadioButton } from '../../../components';

import css from './SignupForm.module.css';
import ReCAPTCHA from 'react-google-recaptcha';

const SignupFormComponent = props => (
  <FinalForm
    {...props}
    mutators={{ ...arrayMutators }}
    render={fieldRenderProps => {
      const {
        rootClassName,
        className,
        formId,
        form,
        handleSubmit,
        inProgress,
        invalid,
        intl,
        values,
        pristine,
        configListing,
        termsAndConditions,
        params,
        recaptcha,
        recaptchaError
      } = fieldRenderProps;
      console.log(values, params);


      // email
      const emailRequired = validators.required(
        intl.formatMessage({
          id: 'SignupForm.emailRequired',
        })
      );
      const emailValid = validators.emailFormatValid(
        intl.formatMessage({
          id: 'SignupForm.emailInvalid',
        })
      );

      // password
      const passwordRequiredMessage = intl.formatMessage({
        id: 'SignupForm.passwordRequired',
      });
      const passwordMinLengthMessage = intl.formatMessage(
        {
          id: 'SignupForm.passwordTooShort',
        },
        {
          minLength: validators.PASSWORD_MIN_LENGTH,
        }
      );
      const passwordMaxLengthMessage = intl.formatMessage(
        {
          id: 'SignupForm.passwordTooLong',
        },
        {
          maxLength: validators.PASSWORD_MAX_LENGTH,
        }
      );
      const passwordMinLength = validators.minLength(
        passwordMinLengthMessage,
        validators.PASSWORD_MIN_LENGTH
      );
      const passwordMaxLength = validators.maxLength(
        passwordMaxLengthMessage,
        validators.PASSWORD_MAX_LENGTH
      );
      const companyRequired = validators.requiredStringNoTrim(intl.formatMessage({
        id: 'SignupForm.companyRequired',
      }));

      const passwordRequired = validators.requiredStringNoTrim(passwordRequiredMessage);
      const passwordValidators = validators.composeValidators(
        passwordRequired,
        passwordMinLength,
        passwordMaxLength
      );
      // typeof window != 'undefined' && window.localStorage.setItem('signupValues', JSON.stringify(values));

      const classes = classNames(rootClassName || css.root, className);
      const submitInProgress = inProgress;
      const submitDisabled = invalid || submitInProgress;


      return (
        <Form className={classes} onSubmit={handleSubmit}>
          <div>
            <div className={css.radioRow}>

              {(!params || Object.keys(params).length === 0 || params.type === 'pro') && (
                <FieldRadioButton
                  id="fractionalPro"
                  name="accountType"
                  label={intl.formatMessage({ id: 'SignupForm.fractionalPro' })}
                  value="fractionalPro"
                  showAsRequired={pristine}
                />
              )}

              {(!params || Object.keys(params).length === 0 || params.type === 'company') && (
                <FieldRadioButton
                  id="company"
                  name="accountType"
                  label={intl.formatMessage({ id: 'SignupForm.company' })}
                  value="company"
                  showAsRequired={pristine}
                />
              )}
            </div>
            <FieldTextInput
              className={css.inputField}
              type="email"
              id={formId ? `${formId}.email` : 'email'}
              name="email"
              autoComplete="email"
              label={intl.formatMessage({
                id: 'SignupForm.emailLabel',
              })}
              placeholder={intl.formatMessage({
                id: 'SignupForm.emailPlaceholder',
              })}
              validate={validators.composeValidators(emailRequired, emailValid)}
            />
            <div className={css.name}>
              <FieldTextInput
                className={css.firstNameRoot}
                type="text"
                id={formId ? `${formId}.fname` : 'fname'}
                name="fname"
                autoComplete="given-name"
                label={intl.formatMessage({
                  id: 'SignupForm.firstNameLabel',
                })}
                placeholder={intl.formatMessage({
                  id: 'SignupForm.firstNamePlaceholder',
                })}
                validate={validators.required(
                  intl.formatMessage({
                    id: 'SignupForm.firstNameRequired',
                  })
                )}
              />
              <FieldTextInput
                className={css.lastNameRoot}
                type="text"
                id={formId ? `${formId}.lname` : 'lname'}
                name="lname"
                autoComplete="family-name"
                label={intl.formatMessage({
                  id: 'SignupForm.lastNameLabel',
                })}
                placeholder={intl.formatMessage({
                  id: 'SignupForm.lastNamePlaceholder',
                })}
                validate={validators.required(
                  intl.formatMessage({
                    id: 'SignupForm.lastNameRequired',
                  })
                )}
              />
            </div>

            {values.accountType == 'fractionalPro'
              ? <FieldSelect
                id={`${formId}.mainProfession`}
                className={css.mainProfessionField}
                name="mainProfession"
                label={intl.formatMessage({ id: 'SignupForm.mainProfession' })}
              >
                <option disabled value="">
                  {intl.formatMessage({ id: 'SignupForm.selectQuantityOption' })}
                </option>
                {configListing?.newCompanyIndustry?.map(({ option, label }) => (
                  <option key={option} value={option}>
                    {label}
                  </option>
                ))}
              </FieldSelect>
              : <FieldTextInput
                className={css.mainProfessionField}
                type="text"
                id={formId ? `${formId}.companyName` : 'companyName'}
                name="companyName"
                label={intl.formatMessage({
                  id: 'SignupForm.companyNameLabel',
                })}
                placeholder={''}
                validate={companyRequired}
              />}

            <div className={css.passwordWrapper}>
              <FieldTextInput
                className={css.passwordInputBox}
                type={values.passwordType ? "text" : "password"}
                id={formId ? `${formId}.password` : 'password'}
                name="password"
                autoComplete="current-password"
                label={intl.formatMessage({
                  id: 'SignupForm.passwordLabel',
                })}
                placeholder={intl.formatMessage({
                  id: 'SignupForm.passwordPlaceholder',
                })}
                validate={passwordValidators}
              />
              <span
                type="button"
                className={css.passwordShow}
                onClick={() => form.change('passwordType', !values.passwordType)}
              >
                {values.passwordType ? "Hide" : "Show"}
              </span>
            </div>
          </div>

          <br/>

          <ReCAPTCHA ref={recaptcha} sitekey={process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY} />

          <p className={css.captcha}>{recaptchaError?.message}</p>

          <div className={css.bottomWrapper}>
            {termsAndConditions}
            <PrimaryButton type="submit" inProgress={submitInProgress} disabled={submitDisabled}>
              <FormattedMessage id="SignupForm.signUp" />
            </PrimaryButton>
          </div>
        </Form>
      );
    }}
  />
);

SignupFormComponent.defaultProps = { inProgress: false };

SignupFormComponent.propTypes = {
  inProgress: bool,
  termsAndConditions: node.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const SignupForm = compose(injectIntl)(SignupFormComponent);
SignupForm.displayName = 'SignupForm';

export default SignupForm;
